import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedRiskExposureInfoData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { riskExposureCalculatorDto, ErrorResponse } from "types";


type UseGetRiskExposureCalculatorMethodQueryProps = {
	creditReviewId: string;
};

const useGetRiskExposureCalculatorMethodQuery = ({
	creditReviewId,
}: UseGetRiskExposureCalculatorMethodQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["creditReviewRiskExposureCalculator", creditReviewId],
		() =>
			creditReviewDetailsService.getRiskExposureCalculator({
				creditReviewId,
			}),
		{
			select: (data: riskExposureCalculatorDto) => {
				return getMappedRiskExposureInfoData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetRiskExposureCalculatorMethodQuery;
